export enum PCAFieldMode {
  NONE = 0,
  SEARCH = 1,
  POPULATE = 2,
  DEFAULT = 3,
  PRESERVE = 4,
  COUNTRY = 8,
}
